
export class InvoiceTemplateModel {
	client: InvoiceClientModel = new InvoiceClientModel();
	seller: InvoiceSellerModel = new InvoiceSellerModel();
	carrier: InvoiceCarrierModel = new InvoiceCarrierModel();
	certifier: InvoiceCertifierModel = new InvoiceCertifierModel();
	inventory: InvoiceInventoryModel = new InvoiceInventoryModel();
	hasExtraTax: boolean = false;
	currency: number = 0;
	total: number = 0;
	totalAdvance: number = 0;
	phrase: string = "";
	invoice: InvoiceDataModel = new InvoiceDataModel();
	warehouse!: any;
	type: number = 1;
	items: InvoiceItemModel[] = [];
	totalSubsidy: number = 0;
	collectionPhrases = [
		["PEQUEÑO CONTRIBUYENTE - NO GENERA DERECHO A CREDITO FISCAL", "PEQUEÑO CONTRIBUYENTE - NO GENERA DERECHO A CREDITO FISCAL"],
		["SUJETO A RETENCION DEFINITIVA ISR", "SUJETO A RETENCION DEFINITIVA ISR"],
		["SUJETO A PAGOS TRIMESTRALES", "SUJETO A PAGOS TRIMESTRALES"],
		["SUJETO A RETENCION DEFINITIVA ISR", "SUJETO A RETENCION DEFINITIVA ISR"],
		["SUJETO A PAGOS TRIMESTRALES", "SUJETO A PAGOS TRIMESTRALES"]
	]
	hasRegularExtraTax: boolean = false;
	totalIVAExempt: number = 0;
	totalIDPExempt: number = 0;

	setPhrase(scenery: ScenerySAT) {
		if (scenery == null || scenery == undefined) {
			this.phrase = "SUJETO A RETENCION DEFINITIVA ISR";
		} else {
			if (scenery.caseId == null || scenery.caseId == undefined
				|| scenery.scenery == null || scenery.scenery == undefined) {
				this.phrase = "";
			} else {
				if (scenery.scenery > 4) {
					this.phrase = "SUJETO A RETENCION DEFINITIVA ISR";
				} else {
					if (scenery.scenery < 0) {
						this.phrase = "";
					} else {
						this.phrase = (this.collectionPhrases[scenery.scenery][scenery.caseId]) ? this.collectionPhrases[scenery.scenery][scenery.caseId] : "";
					}
				}
			}
		}
	}
}

export class InvoiceInventoryModel {
	name: string;
	date: string;
	warehouse: string;
}

export class InvoiceCarrierModel {
	name: string = "";
	nit: string = "";
	destination: string = "";
	plate: string = "";
	date: string = "";
	description: string = "Traslado de una sucursal a otra";
}

export class ConfigurationInvoice {
	id: number;
	fcolor: string;
	scolor: string;
	tcolor: string;
	slogan: string;

	constructor(id, fcolor, scolor, tcolor, slogan) {
		if (id == null || id <= 0 || id > 7) {
			this.id = 1;
			this.fcolor = "#1D5073";
			this.scolor = "#CCCCCC";
			this.tcolor = "#E1E1E1";
			this.slogan = "";
		} else {
			this.id = id;
			this.fcolor = fcolor;
			this.scolor = scolor;
			this.tcolor = tcolor;
			this.slogan = slogan;
		}
	}
}

export class ScenerySAT {
	caseId: number;
	scenery: number;

	constructor(
		caseId: number,
		scenery: number) {
		this.caseId = caseId;
		this.scenery = scenery;
	}
}

export class InvoiceItemModel {
	code: string = "";
	quantity: number = 0;
	extraTax: number = 0;
	priceWithoutTax: number = 0;
	total: number = 0;
	description: string = "";

	constructor(quantity: any, priceWithoutTax: any, description: any);
	constructor(quantity: any, priceWithoutTax: any, description: any, extraTax: any);

	constructor(quantity: any, priceWithoutTax: any, description: any, extraTax?: any) {
		this.quantity = quantity;
		this.priceWithoutTax = priceWithoutTax;
		this.description = description;
		this.extraTax = extraTax ?? 0;

		this.total = this.quantity * (this.priceWithoutTax + this.extraTax);
	}
}

export class InvoiceDataModel {
	serial: any = "";
	number: any = "";
	date: any = "";
	accountingDate: any = "";
}

export class InvoiceClientModel {
	name: string = "";
	nit: string = "";
	address: string = "";
}

export class InvoiceSellerModel {
	name: string = "";
	nit: string = "";
	street: string = "";
	city: string = "";
	state: string = "";
}

export class InvoiceCertifierModel {
	data: string = "";
	date: string = "";
	signature: string = "";
	nit: string = "";
}